import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-fcm-list',
		path: '/admin/features',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_fcm_list" */ './index'), {
			exportName: 'AdminFcmList',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
